import { handleActions } from "redux-actions";

import {
  SET_LOADING,
  SET_UPDATES_LOADING,
  FETCH_CURRENT_USER_SUCCESS,
  RESET_FILTERS,
  FETCH_ROLES_SUCCESS,
  ADD_ROLE_SUCCESS,
  EDIT_ROLE_SUCCESS,
  SET_SELECTED,
  DELETE_ROLE_SUCCESS,
  FETCH_USERS_PER_ROLE_SUCCESS,
  SET_SELECTED_USERS,
  SET_ERROR,
  COPY_ROLE_SUCCESS,
  FETCH_PERMISSIONS_SUCCESS,
  SET_SELECTED_PERMISSIONS
} from "./rolesSagas";
import sortBy from "lodash/sortBy";

export const initialState = {
  currentUser: {},
  isLoading: true,
  filtersDirty: false,
  roles: {},
  permissions: {},
  primaryButtonDisabled: true,
  status: "idle",
  errors: null,
  selected: {
    roleId: "",
    permissions: [],
    reporting_portal_permissions: [],
    organization: null,
    selectedOrganizations: [],
    identifier: "",
    name: "",
    allUsers: null,
    selectedUsers: [],
  }
};

export default handleActions(
  {
    [SET_UPDATES_LOADING]: (state, action) => ({
      ...state,
      areChartsLoading: action.payload
    }),
    [RESET_FILTERS]: (state) => ({
      ...state,
      filtersDirty: false,
      primaryButtonDisabled: true,
      status: "idle",
      errors: null,
      selected: {
        ...initialState.selected
      }
    }),
    [SET_ERROR]: (state, action) => ({
      ...state,
      status: "failed",
      errors: action.payload
    }),
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_SELECTED]: (state, action) => ({
      ...state,
      selected: {
        ...state.selected,
        ...action.payload
      }
    }),
    [SET_SELECTED_USERS]: (state, action) => {
      let assignedUsers = state.selected.allUsers.filter((user) => user.assigned);
      let newSelected = action.payload.filter((user) => !user.assigned);
      return {
        ...state,
        selected: {
          ...state.selected,
          selectedUsers: [...assignedUsers, ...newSelected]
        }
      };
    },
    [SET_SELECTED_PERMISSIONS]: (state, action) => {
      let ids = action.payload.map((permission) => permission.id);
      return {
        ...state,
        selected: { ...state.selected, permissions: [...state.selected.permissions, ...ids] }
      };
    },
    [COPY_ROLE_SUCCESS]: (state, { payload: { data, organizations } }) => {
      let roles = { ...state.roles };
      organizations.forEach(({ name, id }) => {
        let roleToInsert = data.filter((role) => role.organization_id === id);
        roles[name] = sortByName([roleToInsert[0], ...roles[name]]);
      });
      return {
        ...state,
        status: "success",
        roles
      };
    },
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload
    }),
    [FETCH_ROLES_SUCCESS]: (state, action) => ({
      ...state,
      roles: action.payload
    }),
    [FETCH_PERMISSIONS_SUCCESS]: (state, action) => ({
      ...state,
      permissions: action.payload
    }),
    [FETCH_USERS_PER_ROLE_SUCCESS]: (state, action) => {
      let allUsers = action.payload.map((user) => ({
        ...user,
        name: `${user.last_name}, ${user.first_name} (${user.email}) (${user.current_role})`
      }));
      return {
        ...state,
        selected: {
          ...state.selected,
          allUsers,
          selectedUsers: allUsers.filter((user) => user.assigned)
        }
      };
    },
    [ADD_ROLE_SUCCESS]: (state, { payload: { data, orgName } }) => {
      let roles = {
        ...state.roles,
        [orgName]: sortByName([...state.roles[orgName], data])
      };

      return {
        ...state,
        status: "success",
        roles
      };
    },
    [EDIT_ROLE_SUCCESS]: (state, { payload: { orgName, id, ...rest } }) => {
      let roles = {
        ...state.roles,
        [orgName]: sortByName(
          state.roles[orgName].map((role) => (role.id == id ? { ...role, ...rest } : role))
        )
      };
      return {
        ...state,
        status: "success",
        roles
      };
    },
    [DELETE_ROLE_SUCCESS]: (state, { payload: { orgName, id } }) => {
      let roles = {
        ...state.roles,
        [orgName]: state.roles[orgName].filter((role) => role.id !== id)
      };

      return {
        ...state,
        status: "success",
        roles
      };
    }
  },

  initialState
);

const sortByName = (arr) => {
  return sortBy(arr, (obj) => obj.name);
};
